import React from "react";
import ClassNames from "classnames";

class Terms extends React.Component {
  constructor(props) {
    super(props);

    let title = this.props.data.title;
    let bracketsRe = /\((.*)\)/;
    let hint = title.match(bracketsRe)[0];
    title = title.replace(` ${hint}`, "");
    let quantity = parseInt(title.replace(/^\D+/g, ""));
    let price = parseFloat(this.props.data.price.replace(",", "."));
    let perBoxPrice = price / quantity;
    let amountSaved = Math.ceil( parseFloat( this.props.originalPerBoxPrice ) - perBoxPrice );

    this.state = {
      title: title,
      hint: hint,
      quantity: quantity,
      price: price,
      perBoxPrice: perBoxPrice,
      amountSaved: amountSaved
    };

    this.select = this.select.bind(this);
  }

  select(event) {
    event.preventDefault();
    this.props.handleSelect(this.props.n);
  }

  renderSaveAmount (amountSaved) {
    // Return empty string if difference is 0, no amount to be saved from this purchase
    if( amountSaved === 0 ) {
      return '';
    }

    return [
      <span key={0}>&nbsp;-&nbsp;</span>,
      <span key={1} className="save">
        Save {new Intl.NumberFormat( "en-EN", {
          style : "currency",
          currency : "USD"
        } ).format( amountSaved )}
      </span>
    ]
  }

  renderTag (text, key, matchkey) {
    if( key !== matchkey ) {
      return '';
    }

    return [
      <div key={0} className="badge">
        <span>{text}</span>
      </div>
    ]
  }

  render() {
    let title = this.props.data.title;

    return (
      <li
        className={ClassNames({
          Variant: true,
          active: this.props.selected
        })}
        onClick={this.select}
      >
        {this.renderTag( 'Best Seller', this.props.n, 1 )}
        {this.renderTag( 'Best Value', this.props.n, 2 )}
        <div className="radio" />
        <div className="info">
          <div>
            <span className="title">{this.state.title}</span>
            <span className="hint">{this.state.hint}</span>
          </div>
          <span className="price">
            {new Intl.NumberFormat("en-EN", {
              style: "currency",
              currency: "USD"
            }).format(this.state.perBoxPrice)}{" "}
            / box
          </span>
          {this.renderSaveAmount( this.state.amountSaved )}
        </div>
      </li>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/buy/variant.js